module.exports = __webpack_public_path__ + "static/img/Recruitment skills.ce770e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Recruitment skills.jpg
// module id = VK5Q
// module chunks = 3